var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFileIcon = function SvgFileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 0.938672V3.83005C7.625 4.22209 7.625 4.4181 7.69993 4.56784C7.76585 4.69956 7.87102 4.80664 8.00038 4.87375C8.14745 4.95005 8.33996 4.95005 8.725 4.95005H11.5647M7.625 11.25H3.5M9 8.45H3.5M11.75 6.34176V11.39C11.75 12.5661 11.75 13.1542 11.5252 13.6034C11.3275 13.9985 11.0119 14.3198 10.6239 14.5211C10.1827 14.75 9.60511 14.75 8.45 14.75H4.05C2.89489 14.75 2.31734 14.75 1.87614 14.5211C1.48806 14.3198 1.17254 13.9985 0.974799 13.6034C0.75 13.1542 0.75 12.5661 0.75 11.39V4.11C0.75 2.93389 0.75 2.34583 0.974799 1.89662C1.17254 1.50148 1.48806 1.18022 1.87614 0.978886C2.31734 0.75 2.89489 0.75 4.05 0.75H6.2581C6.76256 0.75 7.0148 0.75 7.25217 0.808023C7.46262 0.859466 7.6638 0.944315 7.84834 1.05946C8.05648 1.18932 8.23484 1.37092 8.59155 1.73412L10.7835 3.96588C11.1402 4.32908 11.3185 4.51068 11.4461 4.7226C11.5592 4.91049 11.6425 5.11534 11.693 5.32961C11.75 5.5713 11.75 5.82812 11.75 6.34176Z",
    stroke: "#707070",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fileIcon.c0702f1d.svg";
export { ForwardRef as ReactComponent };